import { render, staticRenderFns } from "./MLRequests.vue?vue&type=template&id=0290d2ac"
import script from "./MLRequests.vue?vue&type=script&lang=js"
export * from "./MLRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0290d2ac')) {
      api.createRecord('0290d2ac', component.options)
    } else {
      api.reload('0290d2ac', component.options)
    }
    module.hot.accept("./MLRequests.vue?vue&type=template&id=0290d2ac", function () {
      api.rerender('0290d2ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/analytic-services/modules/mlops/MLRequests.vue"
export default component.exports